import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=3e815831"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports